import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatNumber(num) {
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
    }
    return num?.toString() || '0';
}

export function formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(amount);
}

export function formatPercent(value) {
    return `${(value || 0).toFixed(1)}%`;
}

export function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    }).format(date);
}

export function formatDateRange(start, end) {
    return `${formatDate(start)} - ${formatDate(end)}`;
}

export function getWeekNumber(dateString) {
    const date = new Date(dateString);
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const diff = date - startOfYear;
    const oneWeek = 1000 * 60 * 60 * 24 * 7;
    return Math.ceil(diff / oneWeek);
}

export function calculatePercentage(part, total) {
    if (!total || total === 0) return 0;
    return ((part / total) * 100).toFixed(1);
}

export function calculateGrowth(current, previous) {
    if (!previous || previous === 0) return 0;
    return (((current - previous) / previous) * 100).toFixed(1);
}

export function getChannelColor(channel) {
    const colors = {
        linkedin: '#0077B5',
        email: '#EA4335',
        ads: '#FBBC05',
        inbound: '#34A853',
    };
    return colors[channel?.toLowerCase()] || '#FF3B30';
}

export function getStatusColor(status) {
    const colors = {
        success: '#10B981',
        warning: '#F59E0B',
        error: '#EF4444',
        info: '#3B82F6',
    };
    return colors[status] || '#A1A1AA';
}

export function getTierColor(tier) {
    const colors = {
        'Tier 1': '#FF3B30',
        'Tier 2': '#F59E0B',
        'Tier 3': '#3B82F6',
    };
    return colors[tier] || '#A1A1AA';
}
